import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Bootstrap the Angular application.
 */
bootstrapApplication(App, appConfig)
  .catch((err) => console.error('[Bootstrap] Application initialization failed:', err));